module.exports = __webpack_public_path__ + "static/img/Live1.3ca688f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/liveroadcast/Live1.png
// module id = nxp8
// module chunks = 1